(function () {
  if (window.__phPop) return; window.__phPop = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function mark() {
    var groups = [
      ['main .shopify-section .title, main .shopify-section h2.h1, main .shopify-section h2.h2, main .rich-text__heading', 'ph-title'],
      ['main .card-wrapper', null],
      ['main .multirow .image-with-text__grid', null],
      ['main .icon-bar__column, main .ds-icon-bar .icon-bar__item, main .multicolumn-card', null],
      ['main .rich-text__text, main .rich-text__buttons, main .newsletter__wrapper > *', null]
    ];
    groups.forEach(function (g) {
      var els = document.querySelectorAll(g[0]);
      els.forEach(function (el, i) {
        if (el.closest('.ph-hero') || el.dataset.phDone) return;
        el.dataset.phDone = '1';
        el.classList.add('ph-reveal');
        if (g[1]) el.classList.add(g[1]);
        var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--ph-delay', (Math.min(sib, 6) * 0.08) + 's');
      });
    });
    if (reduce || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.ph-reveal').forEach(function (el) { el.classList.add('ph-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ph-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    document.querySelectorAll('.ph-reveal:not(.ph-in)').forEach(function (el) { io.observe(el); });
  }

  function tilt() {
    if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.addEventListener('mousemove', function (ev) {
      var card = ev.target.closest && ev.target.closest('.card-wrapper');
      document.querySelectorAll('.card-wrapper[data-ph-tilt]').forEach(function (c) {
        if (c !== card) { c.style.transform = ''; c.removeAttribute('data-ph-tilt'); }
      });
      if (!card) return;
      var r = card.getBoundingClientRect();
      var x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
      card.setAttribute('data-ph-tilt', '1');
      card.style.transform = 'perspective(700px) translateY(-6px) rotateX(' + (-y * 6).toFixed(2) + 'deg) rotateY(' + (x * 8).toFixed(2) + 'deg)';
    }, { passive: true });
  }

  function heroVideo() {
    var v = document.querySelector('.ph-hero video');
    if (!v) return;
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } });
    }, { threshold: 0.2 }).observe(v);
  }

  function init() { mark(); tilt(); heroVideo(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', mark);
})();
